export default __webpack_public_path__ + "static/media/arrow.69d19dee.svg";